import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'wt-ui';
import HeatMapScale from '../HeatMapScale';
import i18next from '../../translations/i18n';

const formatTime = (dt) => {
  if (!dt) {
    return 'N/A';
  }
  let aux = dt;
  if (typeof dt === 'string') {
    aux = new Date(dt);
  }
  const monthNames = i18next.t('Months');
  const date = `${aux.getDate() < 10 ? `0${aux.getDate()}` : aux.getDate()}`;
  const monthName = `${JSON.parse(monthNames)[aux.getMonth()]}`;
  const fullYear = `${aux.getFullYear()}`;
  const hours = `${aux.getHours()}`;
  const minutes = `${aux.getMinutes() < 10 ? `0${aux.getMinutes()}` : aux.getMinutes()}`;
  const seconds = `${aux.getSeconds()}`;

  return `${date} ${monthName} ${fullYear}, ${hours}:${minutes}:${seconds}`;
};

const HeatMapHeader = ({ lastUpdated }) => (
  <Box background="transparent" direction="row" justify="between">
    <Box background="transparent">
      <Text>{i18next.t('PercentageChange')}y</Text>
      <Text>
        <span style={{ fontWeight: 'bold' }}>{i18next.t('LastUpdated')}:</span> {formatTime(lastUpdated)}
      </Text>
    </Box>
    <HeatMapScale />
  </Box>
);

HeatMapHeader.propTypes = {
  lastUpdated: PropTypes.string.isRequired,
};

export default HeatMapHeader;
